import { useLocation } from 'react-router-dom';

export default function SettingsPage() {
    const location = useLocation();
    const isSidebarOpen = location?.state?.isSidebarOpen;

    return (
        <div className={`p-6 md:p-10 overflow-auto ${isSidebarOpen ? 'md:ml-64' : 'md:ml-0'}`}>
            <h1 className="text-3xl font-extrabold text-gray-900 dark:text-white">Settings</h1>
            <p className="mt-1 text-gray-500 dark:text-gray-400">Manage your account settings.</p>
            <div className="mt-6 bg-white dark:bg-slate-800 rounded-lg shadow-lg p-6">
                {/* Future settings like "Change Password" or "Delete Account" would go here */}
                <p>Settings page is under construction.</p>
            </div>
        </div>
    );
}